import axios from 'axios';
import get from 'lodash/fp/get';

axios.defaults.withCredentials = true;

const fetchSelf = async () => {
  try {
    const { data: jsonApiData } = await axios.get('/jsonapi');
    const endpoint = get('meta.links.me.href', jsonApiData);
    const uuid = get('meta.links.me.meta.id', jsonApiData);
    return ({ uuid, endpoint });
  } catch (error) {
    console.error('Error fetching user endpoint');
  }
  return ({ uuid: null, endpoint: null });
};

export default fetchSelf;
